import React from 'react';
import Select from 'react-select';
import $ from 'jquery';

class SelectTipoPessoa extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            tiposPessoa: Object.assign({}, props.tiposPessoa),
            value: '0',
            limparTela: true
        };
       this.getTiposPessoaSelecionadas = this.getTiposPessoaSelecionadas.bind(this);
    }

 //limpar seleção caso tenha nova manifestação
    componentWillReceiveProps(nextProps) {
        
        if(this.props.limparSelecao && this.state.limparTela){
            this.setState({value: '0'}); 
             this.setState({ limparTela: false});
        }
        if(nextProps.selecinarId !== this.props.selecinarId){
            this.setState({value: nextProps.selecinarId}); 
                                        
        }
    }
    componentDidMount() {
        
           this.setState({ value: this.props.selecinarId}); 
     }

    getTiposPessoaSelecionadas(val){
        //console.log('getTiposPessoaSelecionadas', val);
        
        this.setState({ value: val});
        this.props.onChangeTipo(val);
    }
 
    render() {
        var lis = null;
       
      //console.log('AcaoEncaminhar SelectTipoPessoa -> ', this.props.tiposPessoa);
      if(!$.isEmptyObject(this.props.tiposPessoa)){
            

                lis =  this.props.tiposPessoa.dado.map(p => ( 
                    { value: p.mIdTipoPessoa.toString(), label: p.mDescricao }
                ));
      }

        return ( 
            <Select multi={this.props.multi} simpleValue  placeholder="Como deseja se identificar?" options={lis} value={this.state.value} onChange={this.getTiposPessoaSelecionadas} clearable={false} />
            )
    }
}

SelectTipoPessoa.protoType = {
    filterme: React.PropTypes.func.isRequired,
    tiposPessoa: React.PropTypes.object.isRequired
}


export default SelectTipoPessoa;



/** WEBPACK FOOTER **
 ** ./src/components/common/SelectTipoPessoa.js
 **/